/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Check if the device running the application is a Mobile or not.
 * @return {boolean} True if the device is it a mobile, false otherwise.
 */
export const isMobile = (): boolean =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

/**
 * Check if the device is running iOS
 * @return {boolean} True if the device is running iOS, false otherwise.
 */
export const isIOS = (): boolean => /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;

/**
 * Check if is Safari browser
 * @return {boolean} True if browser running is Safari, false otherwise.
 */
export const isSafari = (): boolean =>
  navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;

/**
 * Check if the current device is touch only
 * @return {boolean} True if the device is touch-only
 */
export const isTouchDevice = (): boolean => !matchMedia('(hover: hover) and (pointer: fine)').matches;
